import React, { useEffect, useState } from 'react';
import Logo from '../assets/img/xpo_logo.png';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import LoaderGIF from '../assets/img/small_ajax_loader.gif';
import { ToastContainer, toast } from 'react-toastify';

const Checkout = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const { cart } = useSelector((state) => state.cart);
  const userDetail = useSelector((state) => state.auth);
  const cartItemCount = cart.reduce((total, item) => total + item.quantity, 0);
  const [loader, setLoader] = useState(false);

  const [pincode, setPincode] = useState('');
  const [postOffice, setPostOffice] = useState([]);
  const [states, setStates] = useState('');
  const [district, setDistrict] = useState('');
  const [block, setBlock] = useState('');
  const [fname, setFname] = useState('');
  const [lname, setLname] = useState('');
  const [email, setEmail] = useState('');
  const [paymentMode, setPaymentMode] = useState('');

  const toastingMessage = (type, message) => {
    const toastProps = {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      };
      switch (type) {
        case 'warn':
          toast.warn(message, toastProps);
          break;
        case 'success':
          toast.success(message, toastProps);
          break;
        case 'error':
          toast.error(message, toastProps);
          break;
        default:
          toast.info('Default message', toastProps);
      }
  }

  const fetchPostCode = async () => {
      setLoader(true);
      const url = `${apiBaseUrl}getpincode?pincode=${pincode}`;

      const response = await fetch(url);
      const data = await response.json();
      console.log('result',data);
      if (data.type === 'success') {
          setPostOffice(data.data);
          setStates(data.data[0].State)
          setDistrict(data.data[0].District)
          setBlock(data.data[0].Block)
      } else {
          // console.log('No data found for the provided pincode');
          toastingMessage('error','No data found for the provided pincode');
      }
      setLoader(false)
  }

  const makeOrder = () => {

  }

  useEffect(() => {
    if(userDetail?.user?.name == null){
      alert('Need to Login for Checkout');
      navigate(`/`)
    }
    else{
      setFname(userDetail.user.name.split(" ")[0]);
      setLname(userDetail.user.name.split(" ")[1]);
      setEmail(userDetail.user.email);
    }
  },[userDetail])
  return (
    <div>
        <div className="container">
          <div className="py-5 text-center">
            <img className="d-block mx-auto mb-4" src={Logo} alt="" width="72" height="72"/>
            <h1>Checkout</h1>
          </div>
      </div>
      
      <div className="container">
      <div class="row g-5">
      <div class="col-md-5 col-lg-4 order-md-last">
        <h4 class="d-flex justify-content-between align-items-center mb-3">
          <span class="text-primary">Your cart</span>
          <span class="badge bg-primary rounded-pill">{cartItemCount}</span>
        </h4>
        <ul class="list-group mb-3">
        {cart.map((item) => (
          <>
          <li class="list-group-item d-flex justify-content-between lh-sm">
            <div>
              <h6 class="my-0">{item.name}</h6>
              <Link to={`/products/${item.code}`} style={{textDecoration:'none'}}><small class="text-muted">Brief description</small></Link>
            </div>
            <span class="text-muted">₹ {item.price}</span>
          </li>
          </>
        ))}
          
          {/* <li class="list-group-item d-flex justify-content-between bg-light">
            <div class="text-success">
              <h6 class="my-0">Promo code</h6>
              <small>EXAMPLECODE</small>
            </div>
            <span class="text-success">−$5</span>
          </li> */}
          <li class="list-group-item d-flex justify-content-between">
            <span>Total (INR)</span>
            <strong>₹ {cart.reduce((total, item) => total + item.price * item.quantity, 0)}</strong>
          </li>
        </ul>

        {/* <form class="card p-2">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Promo code" />
            <button type="submit" class="btn btn-secondary">Redeem</button>
          </div>
        </form> */}
      </div>
      <div class="col-md-7 col-lg-8">
        <h4 class="mb-3">Billing address</h4>
        <form class="needs-validation" novalidate="">
          <div class="row g-3">
            <div class="col-sm-6">
              <label for="firstName" class="form-label">First name</label>
              <input type="text" class="form-control" id="firstName" onChange={(e) => setFname(e.target.value)} placeholder="" value={fname} required="" />
              <div class="invalid-feedback">
                Valid first name is required.
              </div>
            </div>

            <div class="col-sm-6">
              <label for="lastName" class="form-label">Last name</label>
              <input type="text" class="form-control" id="lastName" onChange={(e) => setLname(e.target.value)} placeholder="" value={lname} required="" />
              <div class="invalid-feedback">
                Valid last name is required.
              </div>
            </div>

            <div class="col-12">
              <label for="email" class="form-label">Email <span class="text-muted">(Optional)</span></label>
              <input type="email" class="form-control" id="email" onChange={(e) => setEmail(e.target.value)} placeholder="" value={email} />
              <div class="invalid-feedback">
                Please enter a valid email address for shipping updates.
              </div>
            </div>

            <div class="col-12">
              <label for="address" class="form-label">Address</label>
              <input type="text" class="form-control" id="address" placeholder="1234 Main St" required="" />
              <div class="invalid-feedback">
                Please enter your shipping address.
              </div>
            </div>

            <div className='row mt-3'>
              <div class="col-md-3">
                <label for="zip" class="form-label">Pincode</label>
                <input type="text" class="form-control" onChange={(e) => setPincode(e.target.value)} id="zip" placeholder="Pincode" maxLength="6" required="" />
                <div class="invalid-feedback">
                  Zip code required.
                </div>
              </div>
              <div class="col-md-1 mt-4 position-relative">
                <button className='btn btn-primary' disabled={loader} type='button' onClick={fetchPostCode}>Check</button>
                {loader && <img src={LoaderGIF} style={{width: "18px",position: "absolute",top: "10px", left: "35px"}}/> }
              </div>
            </div>

            <div className='row mt-5'>
              <div className='col-md-3 mb-3'>
                <label>State</label>
                <input className='form-control' readOnly value={states}/>
              </div>
              <div className='col-md-3 mb-3'>
                <label>District</label>
                <input className='form-control' readOnly value={district}/>
              </div>
              <div className='col-md-3 mb-3'>
                <label>Block</label>
                <input className='form-control' readOnly value={block}/>
              </div>
              <div className='col-md-3 mb-3'>
                <label>Post Office</label>
                <select required className='form-control' name='postoffice'>
                    <option>Select</option>
                    {
                      postOffice && postOffice.map((posts) => (
                        <option value={posts.Name}>{posts.Name}</option>
                      ))
                    }
                </select>
              </div>
            </div>
            
          </div>

          <hr class="my-4" />
          <h4 class="mb-3">Payment Mode</h4>
          <div class="form-check">
            <input type="radio" value="COD" name='payments' onClick={() => setPaymentMode('COD')} class="form-check-input" id="same-address" />
            <label class="form-check-label" value="COD" onClick={() => setPaymentMode('COD')} for="same-address">CASH ON DELIVERY (COD)</label>
          </div>

          <div class="form-check">
            <input type="radio" value="Online" name='payments' onClick={() => setPaymentMode('Online')} class="form-check-input" id="save-info" />
            <label class="form-check-label" value="Online" onClick={() => setPaymentMode('Online')} for="save-info">PAY ONLINE</label>
          </div>

          <hr class="my-4" />


          <button class="w-100 btn btn-primary btn-lg" onClick={() => makeOrder()} type="button">Confirm Make Payment</button>
        </form>
        <ToastContainer/>
      </div>
    </div>
      </div>
    </div>
  );
};

export default Checkout;
